const styles = theme => ({
  root: {
    minWidth: '360px',
    maxWidth: '420px',
    padding: '12px 8px 8px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 8px 8px',
  },
  title: {
    fontSize: '15px',
    fontWeight: 700,
    color: '#212B36',
  },
  count: {
    fontSize: '12px',
    color: '#919EAB',
  },
  group: {
    paddingBottom: '4px',
  },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  groupLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#212B36',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    // Indented under its group so the group checkbox reads as the parent of these.
    paddingLeft: '20px',
  },
  pageTitle: {
    fontSize: '14px',
    color: '#454F5B',
    flexGrow: 1,
    minWidth: 0,
  },
  // Grey: not visible to anyone yet.
  draftBadge: {
    backgroundColor: '#F4F6F8',
    color: '#637381',
    fontSize: '11px',
    fontWeight: 600,
    borderRadius: '6px',
    padding: '2px 8px',
    marginLeft: '8px',
    whiteSpace: 'nowrap',
  },
  // Amber: live, but what learners see is out of date.
  editedBadge: {
    backgroundColor: '#FFF3E0',
    color: '#B76E00',
    fontSize: '11px',
    fontWeight: 600,
    borderRadius: '6px',
    padding: '2px 8px',
    marginLeft: '8px',
    whiteSpace: 'nowrap',
  },
  divider: {
    margin: '4px 0 8px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '0 8px 4px',
  },
  footnote: {
    fontSize: '12px',
    color: '#919EAB',
  },
})

export default styles
